export default __webpack_public_path__ + "static/media/sky.92eb3c9a.jpg";